import cn from "classnames";
import { syncEntityStatusesEnum } from "helpers/enums";
import Tooltip from "rc-tooltip";
import React, { useEffect, useState } from "react";
import { getLastSyncStatus } from "sources/syncStatuses";

const StatusOverlay = ({ id, entityType, lastSyncStatus, organizationTimezone }) => {
    const [syncStatusData, setSyncStatusData] = useState({});
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getLastSyncStatus(entityType, id).then((res) => {
            setSyncStatusData(res);
            setLoaded(true);
        });
    }, []);

    const getStatus = () => {
        switch (lastSyncStatus) {
            case syncEntityStatusesEnum.Success:
                return "Успешная синхронизация с 1С";
            case syncEntityStatusesEnum.Failed:
                return "Ошибка синхронизации с 1С";
        }
    };

    const syncInfo = () => {
        if (!organizationTimezone?.id || !loaded) {
            return <div className="loading loading--small loading--white mt-3" />;
        }
        const { utcOffset } = organizationTimezone;
        const { fixedAt, comment } = syncStatusData;
        const localeFixedAt = new Date(fixedAt).toLocaleString("ru-RU", { timeZone: organizationTimezone.id });
        const offsetArr = (utcOffset.charAt(0) === "-" ? utcOffset : `+${utcOffset}`).split(":");
        const offset = `${offsetArr[0]}:${offsetArr[1]}`;
        return (
            <>
                <div>
                    Дата синхронизации: {localeFixedAt} ({offset})
                </div>
                <i>{comment}</i>
            </>
        );
    };

    return (
        <>
            {getStatus()}
            {syncInfo()}
        </>
    );
};

const SyncStatusInfo = ({ id, externalId, lastSyncStatus, entityType, organizationTimezone }) => {
    const syncStatusIcon = cn("mr-1 align-middle", {
        "icon-uEA85-check-circle text-success": lastSyncStatus === syncEntityStatusesEnum.Success,
        "icon-uEA86-exclamation-circle text-danger": lastSyncStatus === syncEntityStatusesEnum.Failed,
    });

    if (!externalId && (!lastSyncStatus || lastSyncStatus === syncEntityStatusesEnum.NotSynchronized)) {
        return null;
    }

    return (
        <>
            <br />
            {externalId && <small className="text-muted">({externalId})</small>}
            {lastSyncStatus && (
                <Tooltip
                    overlay={
                        <StatusOverlay
                            id={id}
                            entityType={entityType}
                            lastSyncStatus={lastSyncStatus}
                            organizationTimezone={organizationTimezone}
                        />
                    }
                    placement="right"
                >
                    <small className={syncStatusIcon} />
                </Tooltip>
            )}
        </>
    );
};

export default SyncStatusInfo;
